import React, { PropTypes } from 'react'
import classNames from 'classnames'
import "./ImageWithLoader.css"

class ImageWithLoader extends React.Component {
  constructor(props) {
    super(props);
    this.state = { status: 'loading' };
    this.handleLoad = this.handleLoad.bind(this);
    this.handleError = this.handleError.bind(this);
  }
 
  handleLoad() {
    this.setState({ status: 'loaded' });
  }
 
  handleError() {
    this.setState({ status: 'failed' })
  }

  componentWillReceiveProps(nextProps){
    if (nextProps.src !== this.props.src){
      this.setState({'status': 'loading'})
    }
  }

  render() {
    return (
      <div className={classNames("image-container", this.state.status)}>
        <img 
          alt=""
          onLoad={this.handleLoad} onError={this.handleError} 
          {...this.props} 
        />
      </div>
    );
  }
}

ImageWithLoader.propTypes = {
  src: PropTypes.string,
}

export default ImageWithLoader;